import { render, staticRenderFns } from "./Sector.vue?vue&type=template&id=918e49e8"
import script from "./Sector.vue?vue&type=script&lang=js"
export * from "./Sector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports